import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-metrics",
  "use": "icon-metrics-usage",
  "viewBox": "0 0 111.02 112.19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 111.02 112.19\" id=\"icon-metrics\"><defs><style>#icon-metrics .cls-1{font-size:72px;}#icon-metrics .cls-1,#icon-metrics .cls-2{font-family:Rockwell, Rockwell;}#icon-metrics .cls-2{font-size:21px;letter-spacing:0.1em;}#icon-metrics .cls-3{letter-spacing:0.12em;}</style></defs><title>metrics</title><text class=\"cls-1\" transform=\"translate(0 85.44)\">1</text><text class=\"cls-1\" transform=\"translate(33 72.44)\">2</text><text class=\"cls-1\" transform=\"translate(72 60.44)\">3</text><text class=\"cls-2\" transform=\"translate(17 106.44)\">met<tspan class=\"cls-3\" x=\"42.84\" y=\"0\">r</tspan><tspan x=\"54.12\" y=\"0\">ics</tspan></text></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/metrics.svg
// module id = lY42
// module chunks = 102